import initialState from "../initialState";

import {
  TILES_ARE_LOADING,
  TILES_HAVE_BEEN_LOADED_WITH_ERROR,
  TILES_HAVE_LOADED,
  TILE_TYPE_LIST_IS_LOADING,
  TILE_TYPE_LIST_IS_LOADED,
  TILE_TYPE_LIST_IS_LOADED_WITH_ERROR,
  TILES_SUCCESS_MESSAGE_RAISED,
  TILES_ERROR_MESSAGE_RAISED,
  TILES_RESTART_MESSAGES,
  TILES_OF_TYPE_LINKS_ARE_LOADING,
  TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR,
  TILES_OF_TYPE_LINKS_HAVE_LOADED,
  GET_SINGLE_TILE_IS_LOADING,
  GET_SINGLE_TILE_IS_LOADED_WITH_ERROR,
  GET_SINGLE_TILE_IS_LOADED,
  GET_ADITIONAL_TILES,
  UPDATE_TILE_ARR,
} from "../actions/actionTypes";

export default function tileReducer(
  state = initialState.tileReducerState,
  action
) {
  switch (action.type) {
    case TILES_ARE_LOADING: {
      return {
        ...state,
        tilesAreLoading: true,
        tilesAreLoadedWithError: false,
        tiles: [],
        additionalTiles: [],
      };
    }

    case TILES_HAVE_BEEN_LOADED_WITH_ERROR: {
      return {
        ...state,
        tilesAreLoading: false,
        tilesAreLoadedWithError: true,
        tiles: [],
        additionalTiles: [],
      };
    }

    case TILES_HAVE_LOADED: {
      return {
        ...state,
        tilesAreLoading: false,
        tilesAreLoadedWithError: false,
        tiles: action.tiles,
      };
    }
    case GET_ADITIONAL_TILES: {
      return {
        ...state,
        tilesAreLoading: false,
        tilesAreLoadedWithError: false,
        additionalTiles: action.additionalTiles,
      };
    }

    case UPDATE_TILE_ARR: {
      return {
        ...state,
        tilesAreLoading: false,
        updatedTilesData: action.payload,
      };
    }

    case TILES_OF_TYPE_LINKS_ARE_LOADING: {
      return {
        ...state,
        tilesOfTypeLinksAreLoading: true,
        tilesOfTypeLinksAreLoadedWithError: false,
        tilesOfTypeLinks: [],
      };
    }

    case TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR: {
      return {
        ...state,
        tilesOfTypeLinksAreLoading: false,
        tilesOfTypeLinksAreLoadedWithError: true,
        tilesOfTypeLinks: [],
      };
    }

    case TILES_OF_TYPE_LINKS_HAVE_LOADED: {
      return {
        ...state,
        tilesOfTypeLinksAreLoading: false,
        tilesOfTypeLinksAreLoadedWithError: false,
        tilesOfTypeLinks: action.tilesOfTypeLinks,
      };
    }

    case TILE_TYPE_LIST_IS_LOADING: {
      return {
        ...state,
        tileTypesAreLoading: true,
        tileTypesAreLoadedWithError: false,
        tileTypes: [],
      };
    }

    case TILE_TYPE_LIST_IS_LOADED_WITH_ERROR: {
      return {
        ...state,
        tileTypesAreLoading: false,
        tileTypesAreLoadedWithError: true,
        tileTypes: [],
      };
    }

    case TILE_TYPE_LIST_IS_LOADED: {
      return {
        ...state,
        tileTypesAreLoading: false,
        tileTypesAreLoadedWithError: false,
        tileTypes: action.tileTypes,
      };
    }

    case TILES_SUCCESS_MESSAGE_RAISED: {
      return {
        ...state,
        tileSuccessMessage: action.tileSuccessMessage,
      };
    }

    case TILES_ERROR_MESSAGE_RAISED: {
      return {
        ...state,
        tileErrorMessage: action.tileErrorMessage,
      };
    }

    case TILES_RESTART_MESSAGES: {
      return {
        ...state,
        tileSuccessMessage: "",
        tileErrorMessage: "",
      };
    }

    case GET_SINGLE_TILE_IS_LOADING: {
      return {
        ...state,
        singleTileIsLoading: true,
        singleTileIsLoadedWithError: false,
        singleTile: {},
      };
    }

    case GET_SINGLE_TILE_IS_LOADED_WITH_ERROR: {
      return {
        ...state,
        singleTileIsLoadedWithError: true,
        singleTileIsLoading: false,
        singleTile: {},
      };
    }

    case GET_SINGLE_TILE_IS_LOADED: {
      return {
        ...state,
        singleTile: action.singleTile,
        singleTileIsLoadedWithError: false,
        singleTileIsLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
